import * as types from './actionTypes';

export const getPackageSourceList = (payload) => ({
  type: types.GET_PACKAGE_SOURCE_LIST,
  payload,
});

export const setPackageSourceList = (payload) => ({
  type: types.SET_PACKAGE_SOURCE_LIST,
  payload,
});

export const clearPackageSourceList = () => ({
  type: types.CLEAR_PACKAGE_SOURCE_LIST,
});
